export const HR_ONBOARDING_STATES = {
  TODO: 'TODO',
  STARTED: 'STARTED',
  COMPLETED: 'COMPLETED',
  REVIEW: 'REVIEW',
  SUBMITTED: 'SUBMITTED',
  APPROVED: 'APPROVED',
};
